<form *ngIf="caseFormGroup" [formGroup]="caseFormGroup" autocomplete="asgag-dfg">
    <div class="grid">
        <div class="col-3 input-field">
            <label for="reference">Referencia *</label>
            <input pInputText formControlName="reference" placeholder="(Automático)" d-form-field-error />
        </div>
        <div class="col-3 input-field">
            <label for="caseDate">Fecha apertura *</label>
            <p-calendar [firstDayOfWeek]="1" formControlName="caseDate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error appendTo="body" ></p-calendar>
        </div>
        <div class="col-2 input-field">
            <label for="caseModeId">Tipo *</label>
            <p-dropdown formControlName="caseModeId" [options]="caseModes" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Seleccione un tipo" (onChange)="onSelectCaseMode()" d-form-field-error></p-dropdown>
        </div>
        <div class="col-2 input-field">
            <label for="caseTypeId">Tipo de daño *</label>
            <p-dropdown formControlName="caseTypeId" [options]="caseTypes" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Selecciona un tipo de daño" d-form-field-error></p-dropdown>
        </div>
        <div class="col-2 input-field">
            <label for="caseStateId">Estado *</label>
            <p-dropdown formControlName="caseStateId" [options]="caseStates" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Selecciona un estado" d-form-field-error></p-dropdown>
        </div>
        <div class="col-3 input-field">
            <label for="companyId">Compañía *</label>
            <p-dropdown formControlName="companyId" [options]="companies" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Selecciona una compañía" (onChange)="loadContracts()" d-form-field-error></p-dropdown>
        </div>
        <div class="col-3 input-field">
            <label for="contractId">Contrato</label>
            <p-dropdown formControlName="contractId" [options]="contracts" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Selecciona un contrato" (onChange)="onSelectContract()" d-form-field-error></p-dropdown>
        </div>
        <div class="col-2 input-field">
            <label for="caseNumber">Id Expediente *</label>
            <input pInputText formControlName="caseNumber" 
                    [required]="selectedContract==null || !selectedContract.enableCaseNumberGenerate" placeholder="{{(selectedContract?.enableCaseNumberGenerate?'(Automático)':'')}}" d-form-field-error />
        </div>
        <div class="col-2 input-field">
            <label for="notificationNumber">Nº de aviso/Asset ID</label>
            <input pInputText formControlName="notificationNumber" d-form-field-error />
        </div>
        <div class="col-2 input-field">
            <label for="caseNumberSecondary">Id Exp. Secundario</label>
            <input pInputText formControlName="caseNumberSecondary" d-form-field-error />
        </div>
        
        <div class="col-5 input-field">
            <label for="clientId">Asegurado *</label>
            <div class="p-inputgroup">
                <p-dropdown formControlName="clientId" [options]="clients" optionLabel="name" optionValue="id" appendTo="body"
                    (onFilter)="loadClients($event)"
                    [filter]="true" filterBy="name" placeholder="Selecciona un cliente" (onChange)="loadClientInfo()" d-form-field-error></p-dropdown>
                <button [disabled]="case.clientId==null" type="button" pButton icon="pi pi-pencil" (click)="editClient(case.clientId)" styleClass="p-button-warn"></button>
                <button type="button" pButton icon="pi pi-plus" (click)="editClient(null)" styleClass="p-button-warn"></button>
            </div>
        </div>
        <div class="col-5 input-field">
            <label for="clientPolicyId">Nº póliza/Contrato</label>
            <div class="p-inputgroup">
                <p-dropdown formControlName="clientPolicyId" [options]="clientPolicies" optionLabel="displayName" optionValue="id" appendTo="body"
                    [filter]="true" filterBy="displayName" placeholder="Selecciona una póliza" d-form-field-error></p-dropdown>
                <button [disabled]="case.clientPolicyId==null" type="button" pButton icon="pi pi-pencil" (click)="editClientPolicy(case.clientId, case.clientPolicyId)" styleClass="p-button-warn"></button>
                <button [disabled]="case.clientId==null" type="button" pButton icon="pi pi-plus" (click)="editClientPolicy(case.clientId, null)" styleClass="p-button-warn"></button>
            </div>
        </div>
        <div class="col-2 input-field">
            <label for="caseTreatmentId">Tratamiento</label>
            <p-dropdown formControlName="caseTreatmentId" [options]="casesTreatments" optionLabel="name" optionValue="id" appendTo="body"
                [filter]="true" filterBy="name" placeholder="Selecciona un tratamiento" d-form-field-error></p-dropdown>
        </div>
        <div class="col-12 input-field">
            <div class="grid" formGroupName="address">
                <div class="col input-field col-2" >
                    <label for="addressType">Tipo dirección</label>
                    <p-dropdown [(ngModel)]="dropdownTipeAddressId" [ngModelOptions]="{standalone: true}" [options]="dropdownTipeAddress" optionLabel="label" optionValue="value" appendTo="body"
                        [filter]="true" filterBy="label" placeholder="Selecciona tipo" d-form-field-error (onChange)="changeAddress()" [disabled]="addressId!=case.client?.addressId"></p-dropdown>
                </div>
                <div class="col input-field col-2">
                    <label for="addressLine1">Dirección</label>
                    <input pInputText formControlName="addressLine1" type="text" d-form-field-error [autocomplete]="timespan"  />
                </div>
                <div class="col input-field col-2">
                    <label for="zipCode">Código postal *</label>
                    <input pInputText formControlName="zipCode" type="text" d-form-field-error [autocomplete]="timespan"  [required]="true"  />
                </div>
                <div class="col input-field col-2">
                    <label for="city">Ciudad *</label>
                    <input pInputText formControlName="city" type="text" d-form-field-error [autocomplete]="timespan" [required]="true" >
                </div>            
                <div class="col input-field col-2">
                    <label for="countryRegionId">Provincia *</label>
                    <p-dropdown [options]="countriesRegions" formControlName="countryRegionId" optionValue="id" [filter]="true"
                        filterBy="name" optionLabel="name" placeholder="Seleccione provincia" d-form-field-error  [required]="true"
                        showClear (onChange)="loadCountries()" />
                </div>
                <div class="col input-field col-2">
                    <label for="countryCode">País</label>
                    <p-dropdown [options]="countries" formControlName="countryCode" optionValue="code" [filter]="true" appendTo="body"
                        filterBy="name" optionLabel="name" placeholder="Seleccione país" d-form-field-error />
                </div>
            </div>
        </div>
        <div class="col-12 input-field">
            <label for="description">Descripción</label>
            <textarea pInputTextarea formControlName="description" style="field-sizing: content;"
                d-form-field-error></textarea>
        </div>
        <div class="col-12 input-field">
            <label for="notes">Observaciones</label>
            <textarea pInputTextarea formControlName="notes" style="field-sizing: content;"
                d-form-field-error></textarea>
        </div>
        <div class="col-2 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="isUrgent" [binary]="true" value="true" (onChange)="onUrgentChange($event)" />Urgente</label>
        </div>
        <div class="col-2 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="isVIP" [binary]="true" value="true" />VIP</label>
        </div>
       
        <div class="col-2 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="isPrecite" [binary]="true" value="true" />Precita</label>
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
</form>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Expediente urgente" [(visible)]="showUrgentDialog" [modal]="true" [closable]="false"
    appendTo="body" [style]="{width: '450px'}">
    <div class="flex align-items-center gap-3">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
        <span>¿Desea pasar el expediente al estado "{{assignmentPendingState?.name}}" y poner la fecha de revisión el {{urgentRevisionDate | date:'dd/MM/yyyy'}}?</span>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancelUrgentChange()"></button>
        <button pButton label="Aceptar" icon="pi pi-check" (click)="acceptUrgentChange()"></button>
    </ng-template>
</p-dialog>
